import styled from 'styled-components';
import { Link } from 'react-scroll';
import theme from '../const/theme';

export const Button = styled(Link)`
    border: 1px solid transparent;
    margin-top: ${({scroll}) => (scroll === 'true' ? '-10px' : '0px')};
    background-color: ${({ scroll }) => (scroll === 'true' ? 'white' : theme.COLORS.SECONDARY)};
    border-radius: 32px;
    white-space: nowrap;
    padding: ${({ big }) => (big ? '20px 30px' : '0px 16px')};
    height: 35px;
    color: ${({ scroll }) => (scroll === 'true' ? theme.COLORS.SECONDARY : '#FFFFFF')};
    font-family: 'Roboto-regular', sans-serif; 
    font-size: ${({ big }) => (big ? '1.15em' : '.7em')};
    font-weight: 800;
    outline: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease-in-out;
    &:hover{
        transition: all 0.2s ease-in-out;
        background-color: ${({scroll}) => (scroll === 'true' ? 'transparent' : 'white')};
        color: ${({scroll}) => (scroll === 'true' ? 'white' : theme.COLORS.SECONDARY)};
        border: 1px solid ${({scroll}) => (scroll === 'true' ? 'white' : 'transparent')};;
        
    }

    @media screen and (max-width: 360px){
        padding: ${({ big }) => (big ? '14px 48px' : '10px 20px')};
        color: ${({ dark }) => (dark ? '#010606' : '#fff')};
        font-size: ${({ big }) => (big ? '16px' : '12px')};
    }
    @media screen and (max-width: 480px){
        width: ${({ fullwidth }) => (fullwidth ? '100%' : 'auto')};

    }
` 